import { MdKeyboardArrowDown } from "react-icons/md";
import styles from "./NavbarBottomMobile.module.scss";
import { FaSearch } from "react-icons/fa";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
const NavbarBottomMobile = () => {
  const navigate = useNavigate();
  const [fix, setFix] = useState(false);

  const handleScroll = (e) => {
    if (window.scrollY >= 200) {
      setFix(true);
    } else {
      setFix(false);
    }
  };

  window.addEventListener("scroll", handleScroll);
  return (
    // <div className={fix ? "navbarBottom fixed" : "navbarBottom"}>
    <div className={`${styles.navbarBottomMobile} ${fix ? styles.fixed : ""}`}>
      <div className={styles.navbarBottomMobileWrapper}>
        {/* National */}
        <div className={styles.item}>
          <span>World</span>
        </div>
        <div className={styles.item}>
          <span>Entertainment</span>
        </div>
        <div className={styles.item}>
          <span>Technology</span>
        </div>
        <div className={styles.item}>
          <span>Sports</span>
        </div>

        <div className={styles.item} onClick={() => navigate("/search")}>
          <FaSearch size={20} />
        </div>
      </div>
    </div>
  );
};
export default NavbarBottomMobile;
